module.exports = __webpack_public_path__ + "img/TheBitFoundry-The-Bit-Foundry-Digital-Consulting-1500.e8ea25fe.png";